/** AUTO-GENERATED by scripts/gen-definitions.ts - do not edit */

import abi_5c06b1840e1e from "../abis/5c06b1840e1e307bec4b426803081be2250b1a16a89ed3a3272000bfc5fd0d8f.json";
import abi_584ca02aea7f from "../abis/584ca02aea7faacfe17d2edd0078210f747b4f3e85375124d093665ebd969cc3.json";
import abi_bc37a8c681af from "../abis/bc37a8c681af0849ace7cde4b7005b58679dff2abe8276aaedbdeb31e77ee0e9.json";
import abi_ff0785f2d6ec from "../abis/ff0785f2d6ec18ac54f04caf8944b32e80931b6e0ba747eea0e46e53494cbb12.json";
import type { ChainDefinitionsBundle } from "../bundle-types.js";
import manifest from "../chains/testnet/deployments/20260623T205104Z/manifest.json";

export const definitions = {
	latest: {
		FSEnvelopeRegistry: {
			address: "0xf44FF1a0e37D10959B96C3929D0F28E9a7f12A9d",
			abi: abi_ff0785f2d6ec,
		},
		FSPaymentValidator: {
			address: "0x97Ec503b02Cf85A56B2B77194Fc3C62bC74a95D5",
			abi: abi_5c06b1840e1e,
		},
		FSAttachmentRelease: {
			address: "0xF11E568198Ce044f417D094730fcE21b418142ED",
			abi: abi_bc37a8c681af,
		},
	},
	deploymentId: manifest.deploymentId,
	historicalByAddress: {
		"0x042123c31554f8929563b23d839f4f81d932b620": {
			name: "FSPaymentValidator",
			abi: abi_5c06b1840e1e,
		},
		"0x22db0241799022ce61223d570b83c141a9508efb": {
			name: "FSEnvelopeRegistry",
			abi: abi_584ca02aea7f,
		},
		"0x3baa142556de6206dc19d01fad81971ffb8316e2": {
			name: "FSAttachmentRelease",
			abi: abi_bc37a8c681af,
		},
		"0x3e5c6798a4c36d201713a4c525e467265552f87e": {
			name: "FSEnvelopeRegistry",
			abi: abi_ff0785f2d6ec,
		},
		"0x4340973aedebf2688ed2195fa01aa9b6cf0eb778": {
			name: "FSEnvelopeRegistry",
			abi: abi_ff0785f2d6ec,
		},
		"0x460efc836f98c9a6bf4e0481aa62c1a856384061": {
			name: "FSPaymentValidator",
			abi: abi_5c06b1840e1e,
		},
		"0x4af007b2cab61f1832a3a96379dbbd0dacefd357": {
			name: "FSAttachmentRelease",
			abi: abi_bc37a8c681af,
		},
		"0x4b2e6040f00d81c3818db37e7cb6a9f5c31144c3": {
			name: "FSAttachmentRelease",
			abi: abi_bc37a8c681af,
		},
		"0x5efbc123c180419f5386e538ff064d29e3f0eb81": {
			name: "FSAttachmentRelease",
			abi: abi_bc37a8c681af,
		},
		"0x746bbd2bf0ceb9c58f596ae04bd7b1318f99b7d1": {
			name: "FSAttachmentRelease",
			abi: abi_bc37a8c681af,
		},
		"0x8051ae7d964c7289560965f5ae88e1400e00a344": {
			name: "FSPaymentValidator",
			abi: abi_5c06b1840e1e,
		},
		"0x92f8f4cefb4a390e3c9e6beb9e488b3fae2294c6": {
			name: "FSEnvelopeRegistry",
			abi: abi_ff0785f2d6ec,
		},
		"0x9fce6c3c620a6c9743dc225de510726babec5806": {
			name: "FSPaymentValidator",
			abi: abi_5c06b1840e1e,
		},
		"0xac9312374361da2a3eddec8b31f6bbd226b2405c": {
			name: "FSPaymentValidator",
			abi: abi_5c06b1840e1e,
		},
		"0xb48021def5a590ec400ed0a7e9228efe9aa1cefd": {
			name: "FSAttachmentRelease",
			abi: abi_bc37a8c681af,
		},
		"0xc55ae92508086886313b3087a936c2aa77bd125e": {
			name: "FSEnvelopeRegistry",
			abi: abi_ff0785f2d6ec,
		},
		"0xd738e4756b0189ba08d1f87961e1a3741a4afec1": {
			name: "FSEnvelopeRegistry",
			abi: abi_ff0785f2d6ec,
		},
		"0xdbd9736c45b1bf981d479f4daf4db641f5b1a79d": {
			name: "FSPaymentValidator",
			abi: abi_5c06b1840e1e,
		},
	},
} satisfies ChainDefinitionsBundle;
